<template>
  <div id="hrms15e-detail3">
    <div v-show="detail3Disp">
      <div v-if="!detailDisabled3">
        <div v-if="parseInt(detail.table.rows.length) > 0">
          <div class="detail detail-responsive">
            <div class="detail-header" ><h4><u>{{ labels['HRAP31EC5']['90'] }}</u></h4></div>
            <div class="col-md-12 clear-padding"  >
              <div class="evaluation-wrapper" style="border: none;">
                <div class="evaluation-body" v-show="groupDisp" style="border:1px solid #BDBDBD; margin-bottom: 10px;">
                  <div class="evaluation-section clearfix">
                    <template v-for="(dataGroup, index) in detail.table.rows">
                      <div name="hrms15e-item" class="evaluation-item clearfix">
                        <div class="col-xs-12 subject">
                          {{ labels['HRAP31EC5']['100'] }} {{ dataGroup.kpino }} {{ dataGroup.kpiitem }}
                        </div>
                        <div class="col-xs-12 special">
                          {{ labels['HRAP31EC5']['120'] }} {{ dataGroup.desc_status }} <a class="fa fa-pencil" href="#" @click="infoDetail(dataGroup, index)"></a>
                        </div>
                        <div class="col-xs-12 clear-padding ">
                          <div class="col-xs-12 clear-padding">
                            <div class="weight-box clearfix">
                              <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-star"></i> {{ labels['HRAP31EC5']['130'] }} : {{ dataGroup.kpiwgt }}</div>
                              <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-list-ul"></i> {{ labels['HRAP31EC5']['140'] }} : {{ dataGroup.qtyscor }}</div>
                              <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-pie-chart"></i> {{ labels['HRAP31EC5']['150'] }} : {{ dataGroup.avgscor }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 clear-padding margin-b-5" >
              <div class="evaluation-sum">
                <form class="form-horizontal">
                  <div class="form-group margin-b-5">
                    <label class="col-md-10 control-label">{{ labels['HRAP31EC5']['140'] }}</label>
                    <label class="col-md-2 control-label">{{ labels['HRAP31EC5']['150'] }}</label>
                  </div>
                </form>
                <form class="form-horizontal">
                  <div class="form-group margin-b-5">
                    <label class="col-md-8 control-label">{{ labels['HRAP31EC5']['180'] }}</label>
                    <div class="col-md-2">
                      <div class="form-control readonly-field-color">{{ detail.detail.sumscor }}</div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-control readonly-field-color">{{ detail.detail.sumavg }}</div>
                    </div>
                  </div>
                </form>
                <form class="form-horizontal">
                  <div class="form-group margin-b-5">
                    <label class="col-md-3 control-label">{{ labels['HRAP31EC5']['160'] }}</label>
                    <div class="col-md-5 align-l">
                      <div class="form-control readonly-field-color">{{ detail.detail.desc_codcomp }}</div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-control readonly-field-color">{{ detail.detail.qtyscorcp }}</div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-control readonly-field-color">{{ detail.detail.avgscor }}</div>
                    </div>
                  </div>
                </form>
                <form class="form-horizontal">
                  <div class="form-group margin-b-5">
                    <label class="col-md-8 control-label">{{ labels['HRAP31EC5']['170'] }}</label>
                    <div class="col-md-2">
                      <div class="form-control readonly-field-color">{{ detail.detail.sumscrnet }}</div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-control readonly-field-color">{{ detail.detail.sumavgnet }}</div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="box-footer">
            <div class="col-md-12 clear-padding">
              <div class="dropup" align="right">
                <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ labels['HRAP31EC3']['320'] }}
                  <span class="caret"></span>
                </button>
                <ul class="dropdown-menu pull-right" aria-labelledby="dropdownMenu2">
                  <li class="cursor-pointer" v-if="indexSelected.flgtypap === 'T'"><a @click="appraisalOthers()">{{ labels['HRAP31EC5']['200'] }}</a></li>
                  <li class="cursor-pointer"><a @click="lastEvaluation()" >{{ labels['HRAP31EC5']['210'] }}</a></li>
                  <li class="cursor-pointer"><a @click="companyKpi()" v-if="!detail3Desc3Disabled">{{ labels['HRAP31EC5']['220'] }}</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 clear-padding margin-b-5"  v-else >
          <div class="evaluation-sum ">
            <div class="form-group ">
              <label class="col-md-12 control-label align-c">{{ labelsHrms15e['C60'] }}</label>
            </div>
          </div>
        </div>
      </div>

      <div v-if="detail3Desc1Disp">
        <template v-if="!isEmpty(detailTab3Desc1Selected)">
          <div class="detail detail-responsive clearfix">
            <div class="col-md-12 clear-padding">
              <div class="main-topic-box">
                <i class="left-arrow fa fa-angle-left" aria-hidden="true" @click="triggerSetDetailTab3Desc1Selected(-1)"></i>
                <div class="main-topic">{{ labels['HRAP31EC4']['30'] }} {{ detailTab3Desc1Selected.numseq }}</div>
                <i class="right-arrow fa fa-angle-right" aria-hidden="true" @click="triggerSetDetailTab3Desc1Selected(1)"></i>
              </div>
              <div class="detail-header" ><h4><u>{{ labels['HRAP31EC5']['90'] }}</u></h4></div>
              <div class="evaluation-wrapper" style="border: none;">
                <div class="evaluation-body" v-show="groupDisp" style="border:1px solid #BDBDBD; margin-bottom: 10px;">
                  <div class="evaluation-section clearfix">
                    <template v-for="(dataGroup, index) in detailTab3Desc1Selected.table">
                      <div name="hrms15e-item" class="evaluation-item clearfix">
                        <div class="col-xs-12 subject">
                          {{ labels['HRAP31EC5']['100'] }} {{ dataGroup.kpino }} {{ dataGroup.kpiitem }}
                        </div>
                        <div class="col-xs-12 special">
                          {{ labels['HRAP31EC5']['120'] }} {{ dataGroup.desc_status }} <a class="fa fa-info-circle" @click="infoDetailDesc1(dataGroup, index)"></a>
                        </div>

                        <div class="col-xs-12 clear-padding ">
                          <div class="col-xs-12 clear-padding">
                            <div class="weight-box clearfix">
                              <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-star"></i> {{ labels['HRAP31EC5']['130'] }} : {{ dataGroup.kpiwgt }}</div>
                              <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-list-ul"></i> {{ labels['HRAP31EC5']['140'] }} : {{ dataGroup.qtyscor }}</div>
                              <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-pie-chart"></i> {{ labels['HRAP31EC5']['150'] }} : {{ dataGroup.avgscor }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 clear-padding margin-b-5">
              <div class="evaluation-sum">
                <form class="form-horizontal">
                  <div class="form-group margin-b-5">
                    <label class="col-md-10 control-label">{{ labels['HRAP31EC5']['140'] }}</label>
                    <label class="col-md-2 control-label">{{ labels['HRAP31EC5']['150'] }}</label>
                  </div>
                </form>
                <form class="form-horizontal">
                  <div class="form-group margin-b-5">
                    <label class="col-md-8 control-label">{{ labels['HRAP31EC5']['180'] }}</label>
                    <div class="col-md-2">
                      <div class="form-control readonly-field-color">{{ detailTab3Desc1Selected.sumscor }}</div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-control readonly-field-color">{{ detailTab3Desc1Selected.sumavg }}</div>
                    </div>
                  </div>
                </form>
                <form class="form-horizontal">
                  <div class="form-group margin-b-5">
                    <label class="col-md-3 control-label">{{ labels['HRAP31EC5']['160'] }}</label>
                    <div class="col-md-5 align-l">
                      <div class="form-control readonly-field-color">{{ detailTab3Desc1Selected.desc_codcomp }}</div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-control readonly-field-color">{{ detailTab3Desc1Selected.qtyscorcp }}</div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-control readonly-field-color">{{ detailTab3Desc1Selected.avgscor }}</div>
                    </div>
                  </div>
                </form>
                <form class="form-horizontal">
                  <div class="form-group margin-b-5">
                    <label class="col-md-8 control-label">{{ labels['HRAP31EC5']['170'] }}</label>
                    <div class="col-md-2">
                      <div class="form-control readonly-field-color">{{ detailTab3Desc1Selected.sumscrnet }}</div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-control readonly-field-color">{{ detailTab3Desc1Selected.sumavgnet }}</div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="evaluation-sum ">
            <div class="form-group ">
              <label class="col-md-12 control-label align-c">{{ labelsHrms15e['C70'] }} {{ labels['HRAP31EC3']['230'] }}</label>
            </div>
          </div>
        </template>
      </div>

      <!-- <div v-if="detail3Desc2Disp">
        <template v-if="!isEmpty(detailTab3Desc2)">
          <div class="detail detail-responsive clearfix">
            <div class="col-md-12 clear-padding">
              <div class="detail-header" ><h4><u>{{ labels['HRAP31EC5']['90'] }}</u></h4></div>
              <div class="evaluation-wrapper" style="border: none;">
                <div class="evaluation-body" v-show="groupDisp" style="border:1px solid #BDBDBD; margin-bottom: 10px;">
                  <div class="evaluation-section clearfix">
                    <template v-for="dataGroup in detailTab3Desc2.table.rows">
                      <div name="hrms15e-item" class="evaluation-item clearfix">
                        <div class="col-xs-12 subject">
                          {{ labels['HRAP31EC5']['100'] }} {{ dataGroup.kpino }} {{ dataGroup.kpiitem }}
                        </div>
                        <div class="col-xs-12 special">
                          {{ labels['HRAP31EC5']['120'] }} {{ dataGroup.desc_status }} <a class="fa fa-info-circle" @click="infoDetailDesc2()"></a>
                        </div>
                        <div class="col-xs-12 clear-padding ">
                          <div class="col-xs-12 clear-padding">
                            <div class="weight-box clearfix">
                              <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-star"></i> {{ labels['HRAP31EC5']['130'] }} : {{ dataGroup.kpiwgt }}</div>
                              <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-list-ul"></i> {{ labels['HRAP31EC5']['140'] }} : {{ dataGroup.qtyscor }}</div>
                              <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-pie-chart"></i> {{ labels['HRAP31EC5']['150'] }} : {{ dataGroup.avgscor }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 clear-padding margin-b-5">
              <div class="evaluation-sum">
                <form class="form-horizontal">
                  <div class="form-group margin-b-5">
                    <label class="col-md-10 control-label">{{ labels['HRAP31EC5']['140'] }}</label>
                    <label class="col-md-2 control-label">{{ labels['HRAP31EC5']['150'] }}</label>
                  </div>
                </form>
                <form class="form-horizontal">
                  <div class="form-group margin-b-5">
                    <label class="col-md-8 control-label">{{ labels['HRAP31EC5']['180'] }}</label>
                    <div class="col-md-2">
                      <div class="form-control readonly-field-color">{{ detailTab3Desc2.detail.sumscor }}</div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-control readonly-field-color">{{ detailTab3Desc2.detail.sumavg }}</div>
                    </div>
                  </div>
                </form>
                <form class="form-horizontal">
                  <div class="form-group margin-b-5">
                    <label class="col-md-8 control-label">{{ labels['HRAP31EC5']['170'] }}</label>
                    <div class="col-md-2">
                      <div class="form-control readonly-field-color">{{ detailTab3Desc2.detail.qtyscorcp }}</div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-control readonly-field-color">{{ detailTab3Desc2.detail.avgscor }}</div>
                    </div>
                  </div>
                </form>
                <form class="form-horizontal">
                  <div class="form-group margin-b-5">
                    <label class="col-md-3 control-label">{{ labels['HRAP31EC5']['160'] }}</label>
                    <div class="col-md-5 align-l">
                      <div class="form-control readonly-field-color">{{ detailTab3Desc2.detail.desc_codcomp }}</div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-control readonly-field-color">{{ detailTab3Desc2.detail.sumscrnet }}</div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-control readonly-field-color">{{ detailTab3Desc2.detail.sumavgnet }}</div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="evaluation-sum ">
            <div class="form-group ">
              <label class="col-md-12 control-label align-c">ไม่มี{{ labels['HRAP31EC5']['210'] }}</label>
            </div>
          </div>
        </template>
      </div> -->
    </div>

    <div v-show="detail3Desc2Disp">
      <template v-if="detailTab3Desc2.table !== 'undefined'">
        <hrms-table :columns="detail3Desc2Table"
                    :data="detailTab3Desc2.table"
                    :indexDisp="false"
                    :searchDisp="false" />
      </template>
      <template v-else>
        <div class="evaluation-sum ">
          <div class="form-group ">
            <label class="col-md-12 control-label align-c">{{ labelsHrms15e['C70'] }}{{ labels['HRAP31EC5']['210'] }}</label>
          </div>
        </div>
      </template>
      <!-- <detail3Desc2 :labels="labels"
                    :labelsButton="labelsButton"
                    :detail="detailTab3Desc2"
                    :detail3Desc2Table="detailTab3Desc2.table"
                    :nowLang="nowLang" /> -->
    </div>

    <div v-show="detail3Desc3Disp">
      <detail3Desc3 :labels="labels"
                    :labelsButton="labelsButton"
                    :detail="detailTab3Desc3"
                    :detail3Desc3Table="detail3Desc3Table"
                    :nowLang="nowLang"
                    :detailTab3Desc3Selected="detailTab3Desc3Selected"
                    :setDetailTab3Desc3Selected="setDetailTab3Desc3Selected"
                    :detail3InfoIndexSelected="detail3InfoIndexSelected"
                    :detailTab3Desc3IndexSelected="detailTab3Desc3IndexSelected"
                    :setDetailTab3Desc3IndexSelected="setDetailTab3Desc3IndexSelected"
                    :labelsHrms15e="labelsHrms15e"
                     />
    </div>

    <div v-show="detail3InfoDisp">
      <detail3Info  :labels="labels"
                    :labelsButton="labelsButton"
                    :dropdowns="dropdowns"
                    :nowLang="nowLang"
                    :indexSelected="indexSelected"
                    :searchIndex="searchIndex"
                    :codcomp="detail.detail.codcomp"
                    :qtyscorcp="detail.detail.qtyscorcp"
                    :qtyscor="detail3Selected.qtyscor"
                    :detailCourse="detailCourse"
                    :detail3InfoTable="detail3InfoTable"
                    :postDetail3InfoSave="postDetail3InfoSave"
                    :toggleBackToDetail3="toggleBackToDetail3"
                    :detail3InfoDesc1Disp="detail3InfoDesc1Disp"
                    :setDetail3InfoDesc1Disp="setDetail3InfoDesc1Disp"
                    :popupDetail3InfoDesc2="popupDetail3InfoDesc2"
                    :detail3InfoDesc1Table="detail3InfoDesc1Table"
                    :detail3InfoDesc2PopupTable="detail3InfoDesc2PopupTable"
                    :receivedHrms15eDetailCourse="receivedHrms15eDetailCourse"
                    :inlineDetail3Info="inlineDetail3Info"
                    :setInlineDetail3Info="setInlineDetail3Info"
                    :setDetail3InfoDisp="setDetail3InfoDisp"
                    :receivedHrms15eDetail3InfoDesc2Popup="receivedHrms15eDetail3InfoDesc2Popup"
                    :receivedHrms15eDetailCourseAddInline="receivedHrms15eDetailCourseAddInline"
                    :postDetailCourseSave="postDetailCourseSave"
                    :detail3Info="detail3Info"
                    :detail3InfoSelected="detail3InfoSelected"
                    :setDetail3InfoSelected="setDetail3InfoSelected"
                    :setShowDetailDescDisp="setShowDetailDescDisp"
                    :detail3Desc1Disp="detail3Desc1Disp"
                    :detail3InfoDesc1CourseDisp="detail3InfoDesc1CourseDisp"
                    :setDetail3InfoDesc1CourseDisp="setDetail3InfoDesc1CourseDisp"
                    :detail3Desc2Disp="detail3Desc2Disp"
                    :detail3InfoIndexSelected="detail3InfoIndexSelected"
                    :setDetail3InfoIndexSelected="setDetail3InfoIndexSelected"
                    :validateStaappr="validateStaappr"
                    :toggleTab3InfoBack="toggleTab3InfoBack"
                    :detailAll="detailAll"
                    :calResultScore="calResultScore"
                    :calTotalScore="calTotalScore"
                    ref="detail3Info"
                     />
    </div>
  </div>
</template>

<script>
import group from 'components/hrms15e/group3'
import detail3Desc3 from 'components/hrms15e/detail3Desc3'
import detail3Info from 'components/hrms15e/detail3Info'
import _ from 'lodash'

export default {
  name: 'hrms15e-detail3',
  props: [
    'nowLang',
    'detailDisabled',
    'setDetailDisabled',
    'detailDisabled2',
    'setDetailDisabled2',
    'detail3Desc3Disabled',
    'setDetail3Desc3Disabled',
    'detail3Disp',
    'setDetail3Disp',
    'detail3Desc3Disp',
    'setDetail3Desc3Disp',
    'detail3InfoDisp',
    'setDetail3InfoDisp',
    'detail3InfoDesc1Disp',
    'setDetail3InfoDesc1Disp',
    'popupDetail3InfoDesc2',
    'detail3InfoDesc1Table',
    'detail3InfoDesc2PopupTable',
    'labels',
    'labelsButton',
    'dropdowns',
    'detail',
    'detailAll',
    'detailCourse',
    'toggle',
    'indexSelected',
    'detail3Selected',
    'setDetail3Selected',
    'searchIndex',
    'detail3Desc2Table',
    'detail3Desc3Table',
    'detail3InfoTable',
    'receivedHrms15eDetail3Desc1',
    'receivedHrms15eDetail3Desc2',
    'receivedHrms15eDetail3Desc3',
    'receivedHrms15eDetail3Info',
    'receivedHrms15eDetailCourse',
    'postDetail3InfoSave',
    'inlineDetail3Info',
    'setInlineDetail3Info',
    'receivedHrms15eDetail3InfoDesc2Popup',
    'receivedHrms15eDetailCourseAddInline',
    'postDetailCourseSave',
    'detailTab3Desc3Selected',
    'setDetailTab3Desc3Selected',
    'detail3Info',
    'detail3InfoSelected',
    'setDetail3InfoSelected',
    'detailDisabled3',
    'setDetailDisabled3',
    'detailTab3Desc1',
    'detailTab3Desc1Selected',
    'setDetailTab3Desc1Selected',
    'detail3Desc1Disp',
    'setDetail3Desc1Disp',
    'detailTab3Desc2',
    'detail3Desc2Disp',
    'setDetail3Desc2Disp',
    'setShowDetailDescDisp',
    'setDetail3InfoLeftDisp',
    'detail3InfoDesc1CourseDisp',
    'setDetail3InfoDesc1CourseDisp',
    'detailTab3Desc3',
    'detail3InfoIndexSelected',
    'setDetail3InfoIndexSelected',
    'detailTab3Desc3IndexSelected',
    'setDetailTab3Desc3IndexSelected',
    'validateStaappr',
    'toggleTab3InfoBack',
    'labelsHrms15e',
    'checkCompleteAll',
    'calResultScore',
    'calTotalScore'
  ],
  data () {
    return {
      groupDisp: true,
      detailIndex: 0
    }
  },
  methods: {
    isEmpty () {
      if (this.detailTab3Desc1Selected) {
        return _.isEmpty(this.detailTab3Desc1Selected)
      }
      if (this.detailTab3Desc2) {
        return _.isEmpty(this.detailTab3Desc2)
      }
    },
    saveParams () {
      return this.detail
    },
    appraisalOthers () {
      let detailParams = {
        p_dteyreap: this.searchIndex.year,
        p_numtime: this.searchIndex.numtime,
        p_numseq: this.indexSelected.numseq,
        p_codempid_query: this.indexSelected.codempid
      }
      window.scrollTo(0, 0)
      this.setDetailDisabled(true)
      this.setDetailDisabled3(true)
      this.setDetail3Desc1Disp(true)
      this.setDetail3Desc2Disp(false)
      this.setDetail3InfoDesc1Disp(false)
      this.receivedHrms15eDetail3Desc1(detailParams)
    },
    lastEvaluation () {
      let detailParams = {
        p_dteyreap: this.searchIndex.year,
        p_numtime: this.searchIndex.numtime,
        p_numseq: this.indexSelected.numseq,
        p_codempid_query: this.indexSelected.codempid
      }
      window.scrollTo(0, 0)
      this.setDetailDisabled(true)
      this.setDetailDisabled3(true)
      this.setDetail3Desc1Disp(false)
      this.setDetail3Desc2Disp(true)
      this.receivedHrms15eDetail3Desc2(detailParams)
    },
    companyKpi () {
      let detailParams = {
        p_dteyreap: this.searchIndex.year,
        p_numtime: this.searchIndex.numtime,
        p_codempid_query: this.indexSelected.codempid
      }
      window.scrollTo(0, 0)
      this.setDetail3Desc3Disabled(true)
      this.setDetail3Disp(false)
      this.setDetail3Desc3Disp(true)
      this.setDetail3InfoDisp(false)
      this.receivedHrms15eDetail3Desc3(detailParams)
    },
    infoDetail (dataGroup, index) {
      this.setDetail3InfoIndexSelected(index)
      let detailParams = {
        p_dteyreap: this.searchIndex.year,
        p_numtime: this.searchIndex.numtime,
        p_numseq: this.indexSelected.numseq,
        p_codempid_query: this.indexSelected.codempid,
        rowIndex: index
      }
      let paramLovGrdItem = {
        p_codempid: this.indexSelected.codempid,
        p_dteyreap: this.searchIndex.year,
        p_numtime: this.searchIndex.numtime,
        p_kpino: dataGroup.kpino
      }
      window.scrollTo(0, 0)
      this.setDetail3Selected(dataGroup)
      this.setDetailDisabled(true)
      this.setDetail3Disp(false)
      this.setDetail3Desc3Disp(false)
      this.setDetail3InfoDisp(true)
      this.setDetail3InfoDesc1Disp(true)
      this.setDetail3InfoLeftDisp(true)
      this.receivedHrms15eDetail3Info(detailParams)
      this.$refs.detail3Info.loadLovGrdItem(paramLovGrdItem)
    },
    infoDetailDesc1 (dataGroup, index) {
      this.setDetail3InfoIndexSelected(index)
      let detailParams = {
        p_dteyreap: this.detailTab3Desc1Selected.dteyreap,
        p_numtime: this.detailTab3Desc1Selected.numtime,
        p_numseq: this.detailTab3Desc1Selected.numseq,
        p_codpos: this.detailTab3Desc1Selected.codpos,
        p_codcomp: this.detailTab3Desc1Selected.codcomp,
        p_codempid_query: this.indexSelected.codempid
      }
      let paramLovGrdItem = {
        p_codempid: this.indexSelected.codempid,
        p_dteyreap: this.searchIndex.year,
        p_numtime: this.searchIndex.numtime,
        p_kpino: dataGroup.kpino
      }
      window.scrollTo(0, 0)
      this.setDetailDisabled(true)
      this.setDetail3Disp(false)
      this.setDetail3Desc3Disp(false)
      this.setDetail3InfoDisp(true)
      this.setDetail3InfoDesc1Disp(true)
      this.setDetail3InfoLeftDisp(false)
      this.receivedHrms15eDetail3Info(detailParams)
      this.$refs.detail3Info.loadLovGrdItem(paramLovGrdItem)
    },
    infoDetailDesc2 () {
      let detailParams = {
        p_dteyreap: this.detailTab3Desc1Selected.dteyreap,
        p_numtime: this.detailTab3Desc1Selected.numtime,
        p_codpos: this.detailTab3Desc1Selected.codpos,
        p_codcomp: this.detailTab3Desc1Selected.codcomp,
        p_codempid_query: this.indexSelected.codempid
      }
      window.scrollTo(0, 0)
      this.setDetailDisabled(true)
      this.setDetail3Disp(false)
      this.setDetail3Desc3Disp(false)
      this.setDetail3InfoDisp(true)
      this.setDetail3InfoDesc1Disp(true)
      this.setDetail3InfoLeftDisp(false)
      this.receivedHrms15eDetail3Info(detailParams)
    },
    triggerSetDetailTab3Desc1Selected (index) {
      this.detailIndex += index
      if (this.detailIndex < 0) {
        this.detailIndex = this.detailTab3Desc1.rows.length - 1
      }
      if (this.detailIndex > this.detailTab3Desc1.rows.length - 1) {
        this.detailIndex = 0
      }
      this.setDetailTab3Desc1Selected(this.detailTab3Desc1.rows[this.detailIndex])
    }
  },
  components: {
    group,
    detail3Desc3,
    detail3Info
  }
}
</script>




// WEBPACK FOOTER //
// detail3.vue?2e62559b